






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { SystemModule } from '@/store/modules/system/system.store';
import { PayPalApi } from '@/services/api/api.paypal';
import { DonationPriceViewObject } from '@/types/apiServerContract';

@Component
export default class DonatePayPal extends Vue {
	@Prop({ type: Boolean, default: false }) loading!: boolean;

	selected: DonationPriceViewObject | null = null;

	getPrice(price: DonationPriceViewObject) {
	    return Math.round(price.amount * price.price * 100) / 100;
	}

	get donationSettings() {
	    return SystemModule.paypalSettings;
	}

	get donationItems() {
	    return this.donationSettings?.prices ?? [];
	}

	public async donate() {
	    if (!this.selected) return;

	    this.$emit('update:loading', true);

	    try {
	        const result = await PayPalApi.CreatePayment(this.selected.id);
	        window.open(result.redirectUrl, '_self');
	    } finally {
	        this.$emit('update:loading', false);
	    }
	}

	public async GetDonationSettings() {
	    this.$emit('update:loading', true);

	    try {
	        await SystemModule.GetDonationSettings();
	        this.selected = this.donationItems[0];
	    } finally {
	        this.$emit('update:loading', false);
	    }
	}

	created() {
	    this.GetDonationSettings();
	}
}
